module.exports = __webpack_public_path__ + "static/media/seguradora_allianz.7313b87d.jpg";